import React from "react";
import { AddDetailDrawer } from "./AddDetailDrawer";
import { DataBox } from "./DataBox";
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import { useWarehouseModel } from "../warehouseModel"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function BaseWarehouse() {
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useWarehouseModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Basic Data"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Warehouse Settings"]}</span>
    </>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "仓库名称",
            placeholder: Locale["Warehouse Name"],
            fieldName: "name",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            // placeholder: "仓库类别",
            placeholder: Locale["Warehouse Type"],
            fieldName: "typeCode",
            size: "small",
            options: getSelectedDictOne(DictCodeEnmu.CK_TYPE),
        },

        {
            type: SearchTypeEnum.Select,
            span: 4,
            // placeholder: "状态",
            placeholder: Locale["Status"],
            fieldName: "enable",
            size: "small",
            options: [{ label: Locale["open"], value: 1 }, { label: Locale["close"], value: 0 }]
        }
    ]
    return (
        <>
            <YhPageHeader
                title={PageHeaderTitle}
                triggerSearch={true}
                justify="end"
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={loadData}
                handleReset={resetSearchParam}
            />
            <DataBox />
            <AddDetailDrawer />
        </>
    );
}

